export const DEFAULT_ADD_RATIO_STEPS = [
    {
        stepId: 0,
        label: 'Выбор коэффициентов',
    },
    {
        stepId: 1,
        label: 'Выбор расценок',
    },
];

export const defaultColDefSet = {
    sortable: true,
};
